module.exports = __webpack_public_path__ + "img/play.6485db49.png";